import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {v4 as uuid} from 'uuid';

import {AuthResponse} from './model/authResponse';
import {Module} from './model/module';
import {SignedRequest} from './model/signedRequest';
import {AuthService} from './services/auth.service';
import {ModulesService} from './services/modules.service';
import {UploadService} from './services/upload.service';

@Injectable()
export class UploadDataManager {
  constructor(private uploadService: UploadService) {}

  public uploadFileToS3(signedRequest: SignedRequest, file: File):
      Observable<string|number> {
    return this.uploadService.uploadFileToS3(signedRequest, file);
  }

  public getSignedUpload(fileName: string, fileType: string):
      Observable<SignedRequest> {
    const name = uuid() + '-' + fileName;
    return this.uploadService.getSignedUpload(name, fileType);
  }

  public uploadUsersToApi(organisation: string, file): Observable<Response> {
    return this.uploadService.uploadUsersToApi(organisation, file);
  }

  public uploadUsersFilterToApi(file): Observable<Response> {
    return this.uploadService.uploadUsersFilterToApi(file);
  }

}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/upload.datamanager.ts